import React, { createContext, ReactNode, useContext, useState } from 'react';

type ConnectorsContextType = {
  areConnectorsLoading: boolean;
  setAreConnectorsLoading: (isLoading: boolean) => void;
};

const ConnectorsContext = createContext<ConnectorsContextType | undefined>(undefined);

export const ConnectorsProvider = ({ children }: { children: ReactNode }) => {
  const [areConnectorsLoading, setAreConnectorsLoading] = useState(true);

  return (
    <ConnectorsContext.Provider value={{ areConnectorsLoading, setAreConnectorsLoading }}>
      {children}
    </ConnectorsContext.Provider>
  );
};

export const useConnectors = () => {
  const context = useContext(ConnectorsContext);
  if (context === undefined) {
    throw new Error('useConnectors must be used within a ConnectorsProvider');
  }
  return context;
};
